import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PlayerWrapper from '../../components/Videos/PlayerWrapper';
import DetailsWrapper from '../../components/Videos/DetailsWrapper';
import * as moviesActions from '../../actions/moviesActions';
import * as audiosActions from '../../actions/audiosActions';
import * as radioActions from '../../actions/radioActions';

class MovieDetailsPage extends React.Component {
  static propTypes = {
    // Actions
    actions: PropTypes.shape({
      getMovie: PropTypes.func,
      getMovieEpisodes: PropTypes.func,
      getMovieThread: PropTypes.func,
      clearMovieData: PropTypes.func,
    }).isRequired,

    audiosActions: PropTypes.shape({
      clearAudios: PropTypes.func,
    }).isRequired,

    radioActions: PropTypes.shape({
      clearRadioPlayer: PropTypes.func,
    }).isRequired,


    // Data
    currentLanguage: PropTypes.string.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string,
      state: PropTypes.object,
    }).isRequired,
    movieId: PropTypes.number.isRequired,
    movieData: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
        PropTypes.bool,
      ])),
    }).isRequired,
    movieEpisodes: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
    movieThread: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.object,
    }).isRequired,
  };

  constructor() {
    super();

    this.seasonChangeHandler = this.seasonChangeHandler.bind(this);
    this.episodeClickHandler = this.episodeClickHandler.bind(this);
  }

  componentDidMount() {
    this.props.audiosActions.clearAudios();
    this.props.radioActions.clearRadioPlayer();
    this.props.actions.getMovie(this.props.movieId);
  }

  componentWillUnmount() {
    this.props.actions.clearMovieData();
  }

  static getDerivedStateFromProps(nextProps) {
    if (nextProps.movieData.status !== null) {
      return {
        isThreadFetching: false,
        isMovieFetching: false,
      };
    }

    return null;
  }

  seasonChangeHandler(e) {
    this.props.actions.getMovieEpisodes(e.target.value);
  }

  episodeClickHandler(e) {
    this.props.actions.getMovieThread(e.target.dataset.id);
  }

  render() {
    // TODO: favorite button
    const {
      currentLanguage,
      movieData,
      movieEpisodes,
      movieThread,
      hasVoucher
    } = this.props;

    return (
      <React.Fragment>
        <PlayerWrapper
          currentLanguage={currentLanguage}
          hasVoucher={hasVoucher}
          location={this.props.location}
          videoDetails={movieData}
          videoEpisodes={movieEpisodes}
          episodeThread={movieThread}
          selectHandler={this.seasonChangeHandler}
          episodeClickHandler={this.episodeClickHandler}
        />

        <DetailsWrapper
          currentLanguage={currentLanguage}
          videoDetails={movieData}
        />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    currentLanguage: state.i18n.currentLanguage,
    hasVoucher: state.user.hasVoucher,
    movieId: parseInt(ownProps.match.params.id, 10),
    movieData: state.movies.movie,
    movieEpisodes: state.movies.episodes,
    movieThread: state.movies.movieThread,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(moviesActions, dispatch),
    audiosActions: bindActionCreators(audiosActions, dispatch),
    radioActions: bindActionCreators(radioActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MovieDetailsPage);
